"use strict";

import $ from 'jquery';
import {EventEmitter} from 'fbemitter';
import swal from 'sweetalert';

import Messages from '../common/Messages';
import AccountChangeRequestService, {
    AccountType, StudentAccountChangeRequest
} from '../endpoints/AccountChangeRequestService';
import Navigation from '../common/Navigation';
import Urls from "../endpoints/Urls";
import {toISODateString} from "../common/Utils";
import {dob} from "../common/validators";
import { wireUpBootstrapDatepicker } from '../common/Utils';
import moment from "moment";

/**
 * This wraps the modal that initiates the registration Process
 */
class InviteModal extends EventEmitter{
    constructor(modalSelector){
        super();
        this.inviteModal = $(modalSelector);
        this.theForm = this.inviteModal.find('form');
    }

    init(){
        let self = this;

        self.inviteModal.on ('show.bs.modal', function(event){

            //clear specified inputs when modal is shown
            self.inviteModal.find('label.error').remove();
            self.inviteModal.find('.error').removeClass("error");

            // InviteModal has a date-picker for the date-of-birth field, when the date-picker is open,
            // the InviteModal's show event is being fired, despite the InviteModal being shown/open.
            // This firing of the show event when the date-picker is open causes all the input fields to be
            // set to null. To prevent this from happening, added a condition such that when the InviteModal
            // is shown and the show event is triggered later due to the opening of the date-picker, do not
            // reset the input fields to null.
            if (!self.inviteModal.is(':visible')) {
                self.inviteModal.find('input:text')
                    .val('')
                    .trigger('change');
            }

        });

        //set first input active after opening
        self.inviteModal.on ('shown.bs.modal', function(){
            self.inviteModal.find('input').filter(':first').trigger('focus');
        });

        self.theForm.on('submit', function(e){
            e.preventDefault();

            let theForm = self.theForm;
            if (theForm.valid() === true){
                let studentAccountChangeRequest = new StudentAccountChangeRequest(
                    theForm.find("#invitation-email").val(), "", "", theForm.find("#invitation-firstName").val(), theForm.find("#invitation-lastName").val(), toISODateString(theForm.find('#invitation-dateOfBirthString').val()));
                // Profile account will not have data for the "account-sub-type" attribute.
                self.emit('send', studentAccountChangeRequest, theForm.data('account-type'), theForm.data('account-sub-type'));
            }
        });

        self.inviteModal.on('click', '.btn-save', function(e){
            e.preventDefault();
            self.theForm.submit();
        });

        dob.addMethod();

        self.theForm.validate({
            rules: {
                'invitation-email-confirm' : {
                    'equalTo': '#invitation-email'
                }
            },
            messages : {
                'invitation-email-confirm' : {
                    'equalTo': 'Email addresses must match'
                }
            }
        });

        wireUpBootstrapDatepicker(this.theForm, {
            //see StudentAccountSetupSpecification.isValidBirthDate
            startDate : moment().subtract(100, 'years').toDate(),
            endDate : moment().toDate(),
            defaultViewDate:  {
                month: moment().subtract(10, 'years').month(),
                year: moment().subtract(10, 'years').year()
            }
        });

    }

    hide(){
        this.inviteModal.modal('hide');
    }

    toggleSendButton(enable) {
        this.inviteModal.find('.btn-save').prop('disabled', enable !== true);
    }

    linkFromSendButton() {
        return this.inviteModal.find('.btn-save').data("create-account-modal-link");
    }

}

let openInviteModalWhenButtonClicked = () => {
    $("#send-invite-modal-open-button").on("click", function() {
        let sendInviteAlertModalSelector = '#send-invite-alert-modal';

        $(sendInviteAlertModalSelector).modal('hide');

        $(sendInviteAlertModalSelector).on('hidden.bs.modal', function () {
            $('#send-invite-modal').modal('show');
        });
    });
};

document.addEventListener("DOMContentLoaded", function() {

    openInviteModalWhenButtonClicked();

    let inviteModal = new InviteModal('#send-invite-modal');
    inviteModal.init();

    inviteModal.addListener('send', function(studentAccountChangeRequest, accountType, accountSubType){

        let isCertificationAccount = accountType === AccountType.CERTIFICATION;

        let createAccountRequest = accountType === AccountType.PROFILE
            ? AccountChangeRequestService.requestProfileAccount(studentAccountChangeRequest)
            : AccountChangeRequestService.requestAccount(studentAccountChangeRequest);

        inviteModal.toggleSendButton(false);

        const createAccountModalLink = inviteModal.linkFromSendButton();

        const verificationCodeLanguage = `
                <p>Thank you. We sent instructions regarding next steps to the email address you provided.</p>
                <p><small></small><i>Didn't receive a verification code?</i> Be sure to check your spam or junk folders. <a href='${createAccountModalLink}' target='_blank' className='btn'>Click here</a> for assistance.</small></p>`;

        createAccountRequest
        .then(() => inviteModal.hide())
        .then(() => {
            swal({
                title: "Email Sent",
                html: true,
                text: verificationCodeLanguage,
                type: "info",
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Continue"
            },
            function(){
                let encodedEmail = encodeURIComponent(studentAccountChangeRequest.email);
                let completeRegistrationUrl = `/register/completeRegistration?emailAddress=${encodedEmail}`;
                if(isCertificationAccount) {
                    completeRegistrationUrl += `&accountSubType=${accountSubType}`;
                }
                Navigation.goto(completeRegistrationUrl);
            });
        })
        .catch(function(error){
            swal({
                title: "Error",
                text: `We were unable to send your invite. ${Messages.CONTACT_SUPPORT}`,
                type: "error",
                confirmButtonText: "Ok" });
        })
        .finally(() => inviteModal.toggleSendButton(true));
    });
});


// WEBPACK FOOTER //
// /mnt/appdata/jenkins/jobs/EC_Registration/workspace/web/app/~/eslint-loader!./js/register/create-account-start-page.js